import { Tracker, TrackerTypeWithClientId } from '../../models/Tracker';
import { TrackerSettingExtraFieldConfig } from '~/models/TrackerSettingExtraFields';

export class MetaPixel implements TrackerTypeWithClientId {
  id: number = Tracker.TYPE_META_PIXEL;
  label: string = 'Meta Pixel';
  isEnabled: boolean = true;
  hasClientId: boolean = true;
  isRequireClientId = true;

  getClientIdRegexp(): RegExp {
    return /^\d{15,16}$/;
  }

  getExtraFields(): TrackerSettingExtraFieldConfig[] {
    return [];
  }
}
